<div class="main-container">
    <div class="notfound">
        <div class="notfound-404">
            <h1>Oops!</h1>
            <h2>{{code}} - {{message}}</h2>
        </div>
        <a href="#">Go TO Homepage</a>
    </div>
</div>